<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Brakujące Dokumenty'" [name]="'Lista'"></app-breadcrumb>
<div class="ofwca-missing-documents-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="ofwca-missing-documents-list-filters">

    <mat-form-field class="ofwca-missing-documents-list-filter">
      <mat-label>Imię</mat-label>
      <input matInput placeholder="Imię" name="contains$firstName" [(ngModel)]="initialFilters.contains$firstName">
    </mat-form-field>

    <mat-form-field class="ofwca-missing-documents-list-filter">
      <mat-label>Nazwisko</mat-label>
      <input matInput placeholder="Nazwisko" name="contains$lastName" [(ngModel)]="initialFilters.contains$lastName">
    </mat-form-field>

    <mat-form-field class="ofwca-missing-documents-list-filter">
      <mat-label>Numer RAU</mat-label>
      <input matInput placeholder="Numer RAU" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
    </mat-form-field>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (majątek)'"
      class="ofwca-missing-documents-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="ofwca-missing-documents-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

  </form>

  <div class="ofwca-missing-documents-list-buttons">
    <button *ngIf="(userPermissions | async).registration.read_report" [disabled]="!(userPermissions | async).registration.read_report" mat-raised-button class="report-button" (click)="downloadReport()">
<mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="ofwcas" >

    <!-- Position Column -->
    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef > Imię i nazwisko OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.uuid]">
          {{element.firstName}} {{element.lastName}}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef > Partner </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner.uuid]">
          {{element.partner.shortName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="rau">
      <th mat-header-cell *matHeaderCellDef> RAU</th>
      <td mat-cell *matCellDef="let element">
        <mat-chip-list>
          <ng-container *ngFor="let rauNumber of element.rauNumbers;">
            <mat-chip (click)="copyMessage(rauNumber.rau)" color="accent" selected>{{rauNumber.rau}}</mat-chip>
          </ng-container>
        </mat-chip-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="diploma">
      <th mat-header-cell *matHeaderCellDef> Dyplom</th>
      <td mat-cell *matCellDef="let element">
        <ng-container >
            <button *ngIf="element.hasDiplomaActive === null " mat-icon-button><mat-icon class="negative-icon">remove</mat-icon></button>
            <button *ngIf="element.hasDiplomaActive === false " mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
            <button *ngIf="element.hasDiplomaActive === true " mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="complete_declaration">
      <th mat-header-cell *matHeaderCellDef> Komplet oświadczeń</th>
    <td mat-cell *matCellDef="let element">
      <ng-container >
        <button *ngIf="element.completeDeclarations" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        <button *ngIf="!element.completeDeclarations" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
      </ng-container>
    </td>
    </ng-container>

    <ng-container matColumnDef="contract_active">
      <th mat-header-cell *matHeaderCellDef> Umowa aktywna</th>
      <td mat-cell *matCellDef="let element">
        <ng-container >
          <button *ngIf="element.contractActive" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
          <button *ngIf="!element.contractActive" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="certificate_tuw_tuw">
      <th mat-header-cell *matHeaderCellDef> Zaświadczenie 40p TUW TUW</th>
      <td mat-cell *matCellDef="let element">
        <ng-container >
          <button *ngIf="element.certificateTuwTuw === null " mat-icon-button><mat-icon class="negative-icon">remove</mat-icon></button>
          <button *ngIf="element.certificateTuwTuw === false" mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
          <button *ngIf="element.certificateTuwTuw === true" mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="training_inter_polska">
      <th mat-header-cell *matHeaderCellDef> Szkolenie wstępne Inter Polska</th>
      <td mat-cell *matCellDef="let element">
        <ng-container >
          <button *ngIf="element.trainingInterPolska === null " mat-icon-button><mat-icon class="negative-icon">remove</mat-icon></button>
          <button *ngIf="element.trainingInterPolska === false " mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
          <button *ngIf="element.trainingInterPolska === true " mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="complete_data">
      <th mat-header-cell *matHeaderCellDef> Komplet danych Unum Życie/LuxMed</th>
      <td mat-cell *matCellDef="let element">
        <ng-container >
          <button *ngIf="element.completeDataUnum  === null " mat-icon-button><mat-icon class="negative-icon">remove</mat-icon></button>
          <button *ngIf="element.completeDataUnum === false "  mat-icon-button><mat-icon class="negative-icon">cancel</mat-icon></button>
          <button *ngIf="element.completeDataUnum === true " mat-icon-button><mat-icon class="positive-icon">check_circle</mat-icon></button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
      <td mat-cell *matCellDef="let element">
        {{element.assetsRegional?.firstName}} {{element.assetsRegional?.lastName}}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
